import './add-credit-card-content.scss';
import Button from '../../Button/Button';
import { useTranslation } from 'react-i18next';
import ButtonEnum from '../../Button/ButtonEnum';
import { useCloseOldModal } from '../../../../store/modal/modalHooks';

const AddCreditCardContent = () => {
  const { t } = useTranslation();
  const closeModal = useCloseOldModal();

  const onAddCreditCard = () => {};

  return (
    <div className="add-credit-card-content">
      <div className="add-credit-card-content-title">
        {t('ADD_NEW_CREDIT_CARD')}
      </div>
      <div className="add-credit-card-content-iframe" />
      <div className="add-credit-card-content-buttons">
        <Button
          type={ButtonEnum.TRANSPARENT}
          text={t('CLOSE_BUTTON')}
          className="add-credit-card-content-cancel-button"
          onClick={closeModal}
        />
        <Button
          type={ButtonEnum.PRIMARY}
          text={t('ADD_CARD')}
          onClick={onAddCreditCard}
        />
      </div>
    </div>
  );
};

export default AddCreditCardContent;
